import axiosClient from "../";
import { getErrorMessageObj } from "../../../container/SportsBookNode/utils/common/functions";

export default class ResultService {
  static getResult(params) {
    return axiosClient
      .get("/sb/getResults", { params })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
}
